// import "./TennisCourt.css";

import tennisData from "../../data/tennisData";

import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const TennisCourt = () => {
  return (
    <>
      <ServiceHero data={tennisData} />

      <ServiceOverview data={tennisData} />

      <ServiceBenefits data={tennisData} />

      <ConstructionProcess />

      <TechnicalSpecs data={tennisData} />

      <ServiceGallery data={tennisData} />

      <WhyChooseService data={tennisData} />

      <ServiceFAQ faqs={tennisData.faqs} />

      <RelatedServices data={tennisData} />

      <ServiceCTA data={tennisData} />
    </>
  );
};

export default TennisCourt;
